module.exports = __webpack_public_path__ + "img/zaragoza_background_hero.450e6435.png";